import { Dispatch, useCallback, useReducer, useRef } from 'react';

/**
 * Builds on useReducer by adding a getState callback which
 * works based on a ref
 *
 * @param reducer {Function}
 * @param initState {Object}
 * @return {(React.ReducerStateWithoutAction<function(*=, *=): *>|React.DispatchWithoutAction|(function(): *))[]}
 */

export const useEnhancedReducer = <State, Action>(
  reducer: (state: State, action: Action) => State,
  initState: State,
): [State, Dispatch<Action>, () => State] => {
  const lastState = useRef(initState);
  const getState = useCallback(() => lastState.current, []);

  return [
    ...useReducer((state: State, action: Action) => {
      const newState = reducer(state, action);
      lastState.current = newState;

      return newState;
    }, initState),
    getState,
  ];
};
